import React from 'react';

const InspectorLabelForwardRef: React.ForwardRefRenderFunction<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
> = (props, ref) => {
  return (
    <div
      ref={ref}
      className="flex items-center px-md py-xs text-title-xsmall text-sys-cont-neutral-default"
      {...props}
    ></div>
  );
};

export const InspectorLabel = React.forwardRef(InspectorLabelForwardRef);

const InspectorSubLabelForwardRef: React.ForwardRefRenderFunction<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement>
> = (props, ref) => {
  return (
    <div
      ref={ref}
      className="flex items-center text-caption-small text-sys-cont-neutral-light"
      {...props}
    ></div>
  );
};

export const InspectorSubLabel = React.forwardRef(InspectorSubLabelForwardRef);
